"use client"
/* */
const locales = {"de-DE": {  "alertIcon.danger": `Status Fehler`,
  "alertIcon.info": `Status Information`,
  "alertIcon.success": `Status Erfolg`,
  "alertIcon.warning": `Status Warnung`,
},"en-US": {  "alertIcon.danger": `Status error`,
  "alertIcon.info": `Status information`,
  "alertIcon.success": `Status success`,
  "alertIcon.warning": `Status warning`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@24b745a6ce9353be513d1f98e927d8d3.mjs.map
